module.exports = __webpack_public_path__ + "static/media/SuisseIntl-Regular-WebS.151e90fe.woff";